import { React, useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import HistoryList from './history';
import Listing from './listing';
import Details from './details';

const LeaseTerminationStatus = () => {
    const apiService = new LeaseApiService();
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [listProperty, setlistProperty] = useState([]);
    const [detailsProperty, setDetailsProperty] = useState([]);
    const [HistoryProperty, setHistoryProperty] = useState([]);
    const [listLeaseNos, setlistLeaseNos] = useState([]);
    const [detailsLeaseNos, setdetailsLeaseNos] = useState([]);
    const [historyLeaseNos, sethistoryLeaseNos] = useState([]);
    const [terminationList, setTerminationList] = useState([]);
    const [historyList, setHistoryList] = useState([]);

    const [formData, setFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
    });
    const [detailsFormData, setDetailsFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        Status: [{ label: 'Select', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
    });
    const [historyFormData, setHistoryFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
    });

    useEffect(() => {
        fetchDropdownData();
    }, [])

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'TerminationListProperties,TerminationListLeaseNos,TerminationStatusLeaseNos,TerminationStatusProperties,TerminationHistoryLeaseNos,TerminationHistoryProperties');
            const res = await apiService.getApiParamater('TERMINATION_MULTI', `?${params.toString()}`);
            setlistProperty([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.TerminationListProperties]);
            setHistoryProperty([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.TerminationHistoryProperties]);
            setlistLeaseNos([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.TerminationListLeaseNos]);
            sethistoryLeaseNos([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.TerminationHistoryLeaseNos]);
            setDetailsProperty(res?.data?.dropdowns?.TerminationStatusProperties)
            setdetailsLeaseNos(res?.data?.dropdowns?.TerminationStatusLeaseNos)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleBackClick = () => {
        window.history.back();
    };
    return (
        <div className="p-3">
            <div className='mb-3'><h6>Lease Termination Status</h6></div>
            <div className='border-box2  p-2' style={{ borderRadius: "8px" }}>
                <div className='col-lg-8 nav nav-pills overslid d-flex gap-4'>
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        List
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)}
                    >
                        History
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <Listing formData={formData} setFormData={setFormData} listProperty={listProperty} listLeaseNos={listLeaseNos} setTerminationList={setTerminationList} terminationList={terminationList} />
            )}
            {gridVisibility[1] && (
                <Details setDetailsFormData={setDetailsFormData} detailsFormData={detailsFormData} detailsProperty={detailsProperty} detailsLeaseNos={detailsLeaseNos} />
            )}
            {gridVisibility[2] && (
                <HistoryList historyFormData={historyFormData} setHistoryFormData={setHistoryFormData} HistoryProperty={HistoryProperty} historyLeaseNos={historyLeaseNos} historyList={historyList} setHistoryList={setHistoryList} />
            )}
        </div >
    );
};

export default LeaseTerminationStatus;